module.exports = __webpack_public_path__ + "b15dc57a8edd95b52cbf4c935398eed4.png";